import type { NavItem, ReviewScreen } from '../types/content';

/** Later maps to the native iNavMenu. */
export const primaryNav: NavItem[] = [
  { label: 'The Mask', anchor: 'the-mask' },
  { label: 'Details', anchor: 'details' },
  { label: 'FAQs', anchor: 'faqs' },
  { label: 'Contact', to: '/contact' },
];

export const reviewScreens: ReviewScreen[] = [
  { label: 'Home', to: '/' },
  { label: 'Contact & support', to: '/contact' },
  { label: 'Contact thank-you', to: '/contact/thank-you' },
  { label: 'Bag', to: '/cart' },
  { label: 'Checkout', to: '/checkout' },
  { label: 'Order confirmation', to: '/order-confirmation' },
];
